import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { BannerContainer } from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/modalBanner.styles';

type Props = {
  managerName: string;
  isAddition: boolean;
};
const EmployeeViewPendingEmployeeConsentBanner = ({ managerName, isAddition }: Props) => (
  <BannerContainer themeColor={ThemeColorType.warning}>
    {isAddition ? (
      <Text14 themeColor={ThemeColorType.white} semiBold>
        {gettext('%(managerName)s has added this timesheet for you.', { managerName })}
      </Text14>
    ) : (
      <Text14 themeColor={ThemeColorType.white} semiBold>
        {gettext('%(managerName)s has edited your timesheet.', { managerName })}
      </Text14>
    )}

    <div>
      <Text14 themeColor={ThemeColorType.white} semiBold>
        {gettext('Waiting for your consent.')}
      </Text14>
    </div>
  </BannerContainer>
);

export default EmployeeViewPendingEmployeeConsentBanner;
